import axios from "axios";
import { basicURL } from "../../apiManager/APIConfig";
import { store } from "../store";

function authHeaders() {
  const token = store.getState().auth?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(path, options = {}) {
  try {
    const res = await axios({
      url: `${basicURL}presentation-images${path}`,
      method: options.method || "GET",
      data: options.data,
      headers: authHeaders(),
    });
    return res.data;
  } catch (error) {
    return {
      ok: false,
      status: error?.response?.status || 500,
      message: error?.response?.data?.message || "Request failed.",
    };
  }
}

export const GetMyPresentationImagesCall = () => request("/mine");

export const DescribeMyPresentationImageCall = (body) =>
  request("/mine/describe", { method: "POST", data: body });

export const RegenerateMyPresentationImageCall = (id, body) =>
  request(`/mine/${id}/regenerate`, { method: "POST", data: body });

export const ConfirmMyPresentationImageCall = (id, body) =>
  request(`/mine/${id}`, { method: "PUT", data: body });

export const GetPublicPresentationImagesCall = () => request("/admin");

export const SuggestPublicPresentationImageCall = (body) =>
  request("/admin/suggest", { method: "POST", data: body });

export const SavePublicPresentationImageCall = (body) =>
  request("/admin", { method: "POST", data: body });

export const UpdatePublicPresentationImageCall = (id, body) =>
  request(`/admin/${id}`, { method: "PUT", data: body });

export const ArchivePublicPresentationImageCall = (id) =>
  request(`/admin/${id}`, { method: "DELETE" });

export const GenerateTeachingImageCall = (body) =>
  request("/mine/generate", { method: "POST", data: body });

export const SearchTeachingImagesCall = (params = {}) => {
  const query = new URLSearchParams();
  if (params.q) query.set("q", params.q);
  if (params.subject) query.set("subject", params.subject);
  if (params.source) query.set("source", params.source);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return request(`/search${suffix}`);
};
